import Pager from './pager.vue'
export default Pager
